import { lazy } from "react";
import logger from "./logger";

// React.lazy con un reintento por recarga. Tras un despliegue (los archivos se copian a mano), una
// pestaña abierta de antes pide un chunk con el hash viejo que ya no existe → "ChunkLoadError".
// En ese caso se recarga la página UNA vez (marca en sessionStorage) para traer el index.html nuevo;
// si vuelve a fallar, el error sigue su curso normal (ErrorBoundary).
const MARCA = "xue_chunk_recargado";

const leerMarca = () => {
    try { return sessionStorage.getItem(MARCA) === "1"; } catch { return false; }
};
const ponerMarca = (v) => {
    try { v ? sessionStorage.setItem(MARCA, "1") : sessionStorage.removeItem(MARCA); } catch { /* sin storage */ }
};

export const lazyConReintento = (importar) =>
    lazy(() =>
        importar()
            .then((mod) => {
                ponerMarca(false); // cargó bien: se permite otro reintento a futuro
                return mod;
            })
            .catch((err) => {
                const esChunk = err?.name === "ChunkLoadError" || /Loading (CSS )?chunk .* failed/i.test(err?.message || "");
                if (esChunk && !leerMarca()) {
                    ponerMarca(true);
                    logger.warn("Chunk no disponible (¿despliegue nuevo?): recargando la página", { detalle: err?.message });
                    window.location.reload();
                    return new Promise(() => {}); // la recarga reemplaza la página
                }
                throw err;
            })
    );

export default lazyConReintento;
